import React, { useState } from 'react';

import { Button, Checkbox, Input } from '../../ps-aspect-design';
import { useSession } from '../../hooks/redux';
import apiClient from 'ps-components/lib/apiClient';
import { FormGroup } from 'ps-design';
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';

import './SFTPSetup.scss';

function SFTPSetup() {
  const [contactEmail, setContactEmail] = useState('');
  const [isForReporting, setIsForReporting] = useState(false);
  const [sftpDetails, setSftpDetails] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [newPassword, setNewPassword] = useState();
  const [error, setError] = useState();
  const session = useSession();
  const orgName = session ? session.organization.name : app.organization.name;
  const orgCode = session ? session.organization.code : app.organization.code;

  function toggleIsForReporting() {
    setIsForReporting(!isForReporting);
  }

  function resetResponses() {
    setSftpDetails({});
    setNewPassword();
    setError();
  }

  async function submitForm() {
    const data = {
      contactEmail: contactEmail,
      isForReporting: isForReporting
    };

    resetResponses();
    setIsSubmitting(true);
    const response = await apiClient.apiPost('/api/subsites/sftp-setup/create', data);

    if (response?.data?.success === false) {
      setError(response?.data?.reason);
    } else if (response?.data) {
      setSftpDetails(response.data);
    }

    setIsSubmitting(false);
  }

  async function resetPassword() {
    resetResponses();
    setIsResetting(true);
    const response = await apiClient.apiPut('/api/subsites/sftp-setup/reset');

    if (response?.data?.success === false) {
      setError(response?.data?.reason);
    } else if (response?.data) {
      setNewPassword(response?.data?.password);
    }

    setIsResetting(false);
  }

  return (
    <div className="sftp-setup">
      <h2 className="pxl-header-lg"> Set up SFTP for {orgName}</h2>
      <FormGroup text="Subsite (not editable)">
        <Input disabled={true} type="text" value={orgCode} />
      </FormGroup>
      <FormGroup text="Organization Name (not editable)">
        <Input disabled={true} type="text" value={orgName} />
      </FormGroup>
      <FormGroup text="Contact Email">
        <Input id="disabled" type="text" onChange={(event, value) => setContactEmail(value)} />
      </FormGroup>
      <FormGroup text="Is for Reporting?" className="reporting-row">
        <Checkbox className="sftp-reporting" value={isForReporting} onChange={toggleIsForReporting} />
      </FormGroup>

      {isSubmitting ? (
        <InPlaceIndicator />
      ) : (
        <Button
          disabled={contactEmail === '' || isSubmitting || isResetting}
          className="sftp-button"
          onClick={submitForm}
        >
          Submit
        </Button>
      )}

      {isResetting ? (
        <InPlaceIndicator />
      ) : (
        !isSubmitting && (
          <Button
            variant="secondary"
            disabled={isSubmitting || isResetting}
            className="sftp-button sftp-reset"
            onClick={resetPassword}
          >
            Reset Password
          </Button>
        )
      )}

      <br />

      {sftpDetails && sftpDetails?.success && (
        <div className="sftp-details">
          <h2 className="pxl-header-md">Results:</h2>
          <pre>{JSON.stringify(sftpDetails, null, 2)}</pre>
        </div>
      )}

      {newPassword && (
        <div>
          <h2 className="pxl-header-md">{`Successfully reset SFTP password: ${newPassword}`}</h2>
        </div>
      )}

      {error && (
        <div>
          <h2 className="pxl-header-md sftp-error">{error}</h2>
        </div>
      )}
    </div>
  );
}

export default SFTPSetup;
